import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import useCardDrag from '../Drag/useCardDrag';

/**
 * One of your Pokémon in play that can be dragged (usePokemonDrags): it wraps what the spot shows, and a tap still
 * goes to the spot's button.
 */
const DraggablePokemon = ({ enabled, place, lift, settledBy, children }) => {
  // A retreat dropped here waits for its Undo with the swap already shown (SwapPreview): let go of the card then.
  const waiting = useSelector((state) => !!(state.undo && state.undo.swap));
  const settled = useMemo(() => ({ settledBy, waiting }), [settledBy, waiting]);
  const { bind, ghost } = useCardDrag({ enabled, place, lift, settledBy: settled });

  return (
    <>
      <div {...bind}>{children}</div>
      {ghost(children)}
    </>
  );
};

DraggablePokemon.propTypes = {
  enabled: PropTypes.bool.isRequired,
  /** Where it's dragged from (Motion/anchorNames). */
  place: PropTypes.string.isRequired,
  /** Called as the drag starts; returns what's dragged (Drag/dropTargets setDragging). */
  lift: PropTypes.func.isRequired,
  /** What's in the spot, as the game sent it: a new one means the game has answered the drop. */
  settledBy: PropTypes.object,
  children: PropTypes.node.isRequired,
};

export default DraggablePokemon;
